var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconBtc = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "btc")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "btc",
    transform: "translate(0.630000, 0.380001)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.9919446,88 C19.6935133,87.9955501 -0.00148274185,68.2957463 0,43.9973146 C0.00148274185,19.6988829 19.6988829,0.00148274185 43.9973146,0 C68.2957463,-0.00148274185 87.9955501,19.6935133 88,43.9919446 C88.0021352,55.6642611 83.3662718,66.8591234 75.1126977,75.1126977 C66.8591234,83.3662718 55.6642611,88.0021352 43.9919446,88 Z",
    id: "Shape-6-path",
    fill: "#F09242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3006987,33.1502606 C60.7102368,26.989774 55.3960789,24.9231571 48.6746533,24.2933309 L48.6746533,15.8103604 L43.4785879,15.8103604 L43.4785879,24.1358744 C42.1106843,24.1358744 40.7132576,24.1358744 39.325672,24.1358744 L39.325672,15.8103604 L34.1689706,15.8103604 L34.1689706,24.3523771 L23.6292242,24.3523771 L23.6292242,29.9125608 C23.6292242,29.9125608 27.4672271,29.8436736 27.4081809,29.9125608 C28.8465567,29.7543247 30.1518454,30.7637479 30.3604908,32.1956805 L30.3604908,55.5779749 C30.3306193,56.0688348 30.1034448,56.5267335 29.7306647,56.8474683 C29.3648243,57.1743701 28.8814488,57.3378647 28.3922842,57.3001558 C28.4611714,57.359202 24.6133276,57.3001558 24.6133276,57.3001558 L23.6292242,63.5098476 L34.0705603,63.5098476 L34.0705603,72.1896387 L39.2666258,72.1896387 L39.2666258,63.6377811 L43.4195417,63.6377811 L43.4195417,72.1502746 L48.6254482,72.1502746 L48.6254482,63.5688938 C57.4036496,63.037478 63.5247722,60.8724508 64.2923728,52.6551882 C64.9123579,46.0420139 61.8025914,43.0897041 56.8328697,41.898939 C59.8540669,40.412943 61.7238631,37.6574538 61.3006987,33.1502606 Z M54.0183343,51.6317207 C54.0183343,58.0874384 42.9570131,57.349361 39.4339233,57.349361 L39.4339233,45.8943985 C42.9570131,45.9042395 54.0183343,44.8906131 54.0183343,51.6317207 Z M51.6072812,35.4924265 C51.6072812,41.3970463 42.3763922,40.6786509 39.4437643,40.6786509 L39.4437643,30.266838 C42.3763922,30.266838 51.6072812,29.3417809 51.6072812,35.4924265 Z",
    id: "Shape-5",
    fill: "#FFFFFF"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBtc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_btc.1a676bd5.svg";
export { ForwardRef as ReactComponent };